module.exports = __webpack_public_path__ + "img/illustration-step-1-02.1ece8a84.svg";